<template>
  <nav class="stepsnav">
    <span class="txt">
      <h4>{{ family }}</h4>
      <h2>{{ title }}</h2>
      <span v-if="this.showConfiguratorPricing && runningTotal > 0">
        <b class="running-total">Running Total:</b> {{ currencyFormatter(runningTotal) }}
        <div class="total-note">Tariff surcharges and associated fees are not included</div>
      </span>
    </span>

    <span class="actions">
      <button
        type="button"
        :disabled="!canStepBack"
        class="back"
        @click="$emit('step-backward')"
      >
        Back
      </button>
      <button
        type="button"
        class="next"
        v-if="!isLastStep"
        :disabled="!canStepForward"
        @click="$emit('step-forward')"
      >
        Next
      </button>
      <button
        class="next"
        v-if="isLastStep"
        :disabled="completeDisabled"
        onclick="location.href='#summary'"
      >
        Complete
      </button>
    </span>
  </nav>
</template>

<script>
import currencyFormatter from "../../../currency_formatter.js";

export default {
  props: [
    "title",
    "family",
    "isLastStep",
    "canStepBack",
    "runningTotal",
    "canStepForward",
    "completeDisabled",
    "showConfiguratorPricing",
  ],
  data() {
    return {
      currencyFormatter,
    };
  },
};
</script>
